"use client";

import { useEffect } from "react";
import { useNavigate } from "react-router";

export function useHashRouteRedirect() {
    const navigate = useNavigate();

    useEffect(() => {
        const redirectOldHashRoute = () => {
            if (location.hash.startsWith("#/")) {
                navigate(location.hash.slice(1), { replace: true });
            }
        };
        redirectOldHashRoute();
        window.addEventListener("hashchange", redirectOldHashRoute);
        return () =>
            window.removeEventListener("hashchange", redirectOldHashRoute);
    }, [navigate]);
}
